/**
 * "Why did the AI file this here?" — hidden by default (SPEC.md §11 item 7b). The reasoning
 * is only useful when troubleshooting or evaluating the parse worker, not on every glance at
 * a task or note it filed, so it stays closed until asked for — `InfoToggle`, not `EyeToggle`:
 * this is a historical explanation of a past decision, not more detail about the item's
 * current state, and the eye glyph promises the latter everywhere else it's used.
 *
 * Renders nothing at all when there's no reasoning to show, which is the common case: most
 * tasks and notes were never touched by the parse worker.
 */

import { useState } from "react";
import type { AiReasoning } from "../api";
import { InfoToggle } from "./InfoToggle";

export function AiReasoningDisclosure({
  reasoning,
}: {
  reasoning: AiReasoning | null | undefined;
}) {
  const [open, setOpen] = useState(false);
  if (!reasoning?.reason) return null;

  return (
    <div className="ai-reasoning row" style={{ alignItems: "flex-start" }}>
      <InfoToggle open={open} onToggle={() => setOpen((v) => !v)} label="why the AI filed this here" />
      {open && (
        <p className="muted small" style={{ margin: 0 }}>
          {reasoning.reason}
          {reasoning.model_key && ` - ${reasoning.model_key}`}
        </p>
      )}
    </div>
  );
}
